import _ from 'lodash'

/** Id do tipo REMESSA_FINANCEIRA, o mesmo do enum TipoCrudIntegracao no backend. */
export const TIPO_REMESSA_FINANCEIRA = 4

export const isCriterioRemessaFinanceira = (record) => {
  return _.get(record, 'tipo.id', null) === TIPO_REMESSA_FINANCEIRA
}

/**
 * Regras de texto que dá para checar sem banco (PHOENIX-943, §6.4). É conveniência: a garantia é o
 * beforeSave do backend, que roda EXPLAIN. Devolve a mensagem do primeiro problema ou null.
 */
export const validarTextoCriterio = (consultaSql) => {
  const texto = _.trim(consultaSql)
  if (!texto) {
    return 'O campo Consulta SQL é obrigatório para o tipo Remessa Financeira'
  }
  if (texto.includes(';')) {
    return "O critério não pode conter ';'. Ele é uma condição sobre o contrato, não um comando SQL"
  }
  if (_.startsWith(_.toUpper(texto), 'SELECT')) {
    return 'O critério deve ser apenas a condição sobre o contrato (ex.: ctr.ativo = true), sem o SELECT — o sistema monta a consulta'
  }
  return null
}

/** Formato usado no critério. Não significa nada aqui (não há requisição), mas a coluna é NOT NULL. */
export const FORMATO_JSON = { id: 2, value: 'JSON' }

/**
 * O `makeNew` do reducer factory zera todo campo objeto para `[]` (`reducer.factory.js:143`), e
 * quem desfaz isso normalmente é o dropdown do campo. Como Formato não aparece no tipo Remessa
 * Financeira, `formato` chegaria ao backend como `[]` e o Jackson quebraria antes de qualquer
 * validação — erro de desserialização, sem mensagem útil. Aqui ele vira JSON, o mesmo default que
 * o `beforeSave` aplica.
 */
export const normalizarCriterioRemessa = (record) => {
  if (!isCriterioRemessaFinanceira(record)) {
    return record
  }
  if (!_.get(record, 'formato.id', null)) {
    record.formato = FORMATO_JSON
  }
  // Requisição é texto e não se aplica ao critério: array vazio quebraria a desserialização igual.
  if (!_.isString(record.requisicao)) {
    record.requisicao = null
  }
  return record
}

/**
 * O checkbox Ativo aparece marcado por padrão, mas `record.ativo` só existe depois que alguém
 * clica nele — e o converter do backend grava `source.isAtivo()`, que vira `false` quando o campo
 * não vem. Sem isto a tela mostraria marcado e o registro nasceria inativo, o que no critério da
 * remessa significa "não filtra nada" (a busca só enxerga critério ativo).
 */
export const normalizarAtivo = (record) => {
  if (!_.isBoolean(record.ativo)) {
    record.ativo = true
  }
  return record
}

/** Embrulho que o sistema monta em volta do que for cadastrado. Exibido como ajuda na tela. */
export const AJUDA_EMBRULHO = `SELECT ctr.oid_contrato
  FROM contrato ctr
 WHERE ctr.oid_empresa = <empresa>
   AND ctr.oid_unidade = <unidade>
   AND ( seu critério aqui )`

export const AJUDA_EXEMPLO = `ctr.ativo = true
  AND NOT EXISTS (SELECT 1
                    FROM remessa_financeira_itens i
                    JOIN lancamento_financeiro l ON l.oid_lancamento_financeiro = i.oid_lancamento_financeiro
                   WHERE l.oid_contrato = ctr.oid_contrato)`
